import { useQuery } from "@tanstack/react-query";
import { getProductListPbf } from "../../../services/purchaseApi";

export const useProductListQueryPbf = (body) =>
    useQuery({
        queryKey: ["purchase-products-pbf", body],
        queryFn: () => getProductListPbf(body),
        keepPreviousData: true,
        refetchOnWindowFocus: false,
    });